"use client";

import useAxiosInstance from "@/hooks/useAxiosInstance";
import { createContext, useEffect, useState } from "react";
import { useAuth } from "./AuthContext";

const AppContext = createContext({});

function AppContextProvider({ children }) {
  const { customer } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const [toggleFetch, setToggleFetch] = useState(false);
  const [customerUpvote, setCustomerUpvote] = useState([]);

  const axiosInstance = useAxiosInstance();

  function triggerFetch() {
    setToggleFetch((prevState) => !prevState);
  }

  return (
    <AppContext.Provider
      value={{
        isLoading,
        setIsLoading,
        triggerFetch,
        toggleFetch,
        setToggleFetch,
        customer,
        customerUpvote,
      }}
    >
      {children}
    </AppContext.Provider>
  );
}

export { AppContextProvider };

export default AppContext;
